import AddNews from './AddNews';

export default AddNews;
